import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "../data/content";
import { Button } from "./ui/button";
import logoFull from "../assets/logo-full.png";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-black/30" data-testid="footer">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={logoFull}
              alt="FCY IT Consultancy logo"
              className="h-24 w-auto object-contain"
              data-testid="footer-logo"
            />
            <p className="text-sm text-muted-foreground mt-4 leading-relaxed max-w-sm">
              Websites, mobile apps, cyber security, e-commerce growth and custom business
              systems — built and supported by one trusted UK consultancy.
            </p>
            <p className="text-sm text-muted-foreground mt-4 space-y-1">
              <a href={`mailto:${COMPANY.email}`} className="hover:text-primary transition-colors block" data-testid="footer-email-link">
                {COMPANY.email}
              </a>
              <a href={`mailto:${COMPANY.email2}`} className="hover:text-primary transition-colors block" data-testid="footer-email2-link">
                {COMPANY.email2}
              </a>
              <a href={`tel:${COMPANY.phoneIntl}`} className="hover:text-primary transition-colors block" data-testid="footer-phone-link">
                {COMPANY.phone}
              </a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-semibold text-foreground text-sm">Explore</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { label: "Services", href: "#services" },
                { label: "Portfolio", href: "#portfolio" },
                { label: "Process", href: "#process" },
                { label: "About", href: "#about" },
                { label: "Clients", href: "#testimonials" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <li key={link.href}>
                  <Button
                    variant="ghost"
                    onClick={() => scrollTo(link.href)}
                    className="h-11 p-0 text-muted-foreground hover:text-foreground hover:bg-transparent"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-semibold text-foreground text-sm">Company Details</h4>
            <div className="mt-4 space-y-2 text-sm text-muted-foreground leading-relaxed">
              <p className="text-foreground">{COMPANY.name}</p>
              <p>Company No. {COMPANY.companyNumber} · Registered in England &amp; Wales</p>
              <p>{COMPANY.address}</p>
              <div className="pt-2 text-xs space-y-1">
                {COMPANY.sicCodes.map((code) => (
                  <p key={code}>SIC {code}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <p>
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p>
            {COMPANY.domain} ·{" "}
            <Link to="/admin" className="hover:text-foreground transition-colors" data-testid="footer-admin-link">
              Admin
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
